import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copyToClipboard from 'copy-to-clipboard';
import cx from 'classnames';
import styles from './styles.module.styl';

const copyBtnClass = 'icon-budicon-470';
const okBtnClass = 'icon-budicon-338';

class CopyButton extends Component {
  state = { copied: false };

  handleCopyCode = () => {
    copyToClipboard(this.props.code);
    this.setState({ copied: true });

    clearTimeout(this.showCopyBtnTimer);
    this.showCopyBtnTimer = setTimeout(() => {
      this.setState({ copied: false });
    }, 1000);
  }

  render() {
    const { small } = this.props;

    return (
      <button
        onClick={this.handleCopyCode}
        className={cx(
          'copy-button',
          'btn',
          'btn-sm',
          small ? [styles.overlay, 'btn-default'] : 'btn-transparent'
        )}
      >
        <span
          className={cx(
            !small && 'btn-icon',
            this.state.copied ? copyBtnClass : okBtnClass
          )}
        />
        {!small && 'Copy'}
      </button>
    );
  }
}

CopyButton.defaultProps = {
  small: false
};

CopyButton.propTypes = {
  code: PropTypes.string.isRequired,
  small: PropTypes.bool
};

export default CopyButton;
